import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { BaseSubMaintenanceController } from '../../_base/BaseSubMaintenanceController';
import { UserRoleListMaintenanceDto } from './UserRoleListMaintenanceDto';
import { UserRoleItemMaintenanceDto } from './UserRoleItemMaintenanceDto';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/public-api';

@Injectable()
export class UserRoleSubMaintenanceController extends BaseSubMaintenanceController<UserRoleListMaintenanceDto, UserRoleItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "system/securityandnotifications/user/role");
    }

    public getResourceRoot(): string {
        return "USER.ROLE";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/securityandnotifications/user/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}